// ==========================================================================
// CACTUS KNIGHT — Visuelle Interaktionen (kein Shopify-Backend)
// ==========================================================================

// Verhindert, dass der Browser beim Laden eine alte Scroll-Position wiederherstellt
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}
window.scrollTo({ top: 0, left: 0, behavior: "instant" });

document.addEventListener("DOMContentLoaded", () => {
  /* ---- Sticky-Header: Kompakt-Modus beim Scrollen + Höhe messen ---- */
  const topbar = document.querySelector(".site-topbar");

  // Zwei getrennte Schwellen (Hysterese): Der Kompakt-Modus schaltet erst bei
  // 90px ein und erst bei 40px wieder aus. Mit nur EINER Schwelle entstand eine
  // Rückkopplung — das Einklappen verkürzt den Header, dadurch verschiebt sich
  // der Inhalt nach oben, scrollY fällt unter die Schwelle, es klappt wieder
  // aus, usw. Genau das war das Zittern an einer bestimmten Scroll-Höhe.
  const COMPACT_ON = 90;
  const COMPACT_OFF = 40;

  function updateTopbarHeight() {
    if (topbar) {
      document.documentElement.style.setProperty("--topbar-height", `${topbar.offsetHeight}px`);
    }
  }

  function updateCompactState() {
    if (!topbar) return;
    const isCompact = topbar.classList.contains("is-compact");
    const y = window.scrollY;
    let changed = false;
    if (!isCompact && y > COMPACT_ON) {
      topbar.classList.add("is-compact");
      changed = true;
    } else if (isCompact && y < COMPACT_OFF) {
      topbar.classList.remove("is-compact");
      changed = true;
    }
    // Beim Umschalten die Höhe für die Dauer der CSS-Animation laufend
    // nachführen. Vorher wurde erst am Ende gemessen — dadurch hingen sticky
    // Elemente (Sprungmarken-Leiste, Sidebar) 0,25s lang am alten Wert fest
    // und "sprangen" sichtbar nach.
    if (changed) trackHeightDuringTransition();
  }

  let heightTrackingUntil = 0;
  let heightTrackingActive = false;

  function trackHeightDuringTransition() {
    heightTrackingUntil = Date.now() + 400;
    if (heightTrackingActive) return;
    heightTrackingActive = true;
    (function step() {
      updateTopbarHeight();
      if (Date.now() < heightTrackingUntil) {
        requestAnimationFrame(step);
      } else {
        heightTrackingActive = false;
      }
    })();
  }

  updateTopbarHeight();
  updateCompactState();

  window.addEventListener("resize", updateTopbarHeight);
  let scrollTicking = false;
  window.addEventListener(
    "scroll",
    () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(() => {
        updateCompactState();
        // Bewusst KEIN Neumessen der Höhe bei jedem Scroll-Frame: Das schrieb
        // laufend Zwischenwerte der CSS-Transition in --topbar-height, worauf
        // sticky Sidebar und Sprungmarken ruckelten. Gemessen wird nur im
        // Ruhezustand (unten per transitionend).
        scrollTicking = false;
      });
    },
    { passive: true }
  );

  // Nach Ende der CSS-Transition exakt nachmessen
  if (topbar) {
    topbar.addEventListener("transitionend", (e) => {
      if (e.target === topbar || e.propertyName === "height" || e.propertyName === "padding-top") {
        updateTopbarHeight();
      }
    });
  }

  /* ---- Accordion (Produktseite) ---- */
  document.querySelectorAll(".accordion-item__trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const item = trigger.closest(".accordion-item");
      item.classList.toggle("is-open");
    });
  });

  /* ---- Mengen-Auswahl (Produktseite) ---- */
  const qtyInput = document.querySelector(".quantity-selector input");
  const qtyMinus = document.querySelector(".quantity-selector [data-qty-minus]");
  const qtyPlus = document.querySelector(".quantity-selector [data-qty-plus]");

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener("click", () => {
      const val = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
      qtyInput.value = val;
    });
    qtyPlus.addEventListener("click", () => {
      const val = Math.max(1, parseInt(qtyInput.value || "1", 10) + 1);
      qtyInput.value = val;
    });
  }

  /* ---- Galerie-Thumbnails, Zoom & Navigation: siehe assets/lightbox.js ---- */

  /* ---- In den Warenkorb: läuft jetzt über das native Shopify-Produktformular
     (templates/product.liquid, form 'product') — kein JS mehr nötig. Nach dem
     Absenden leitet Shopify per "return_to"-Feld direkt zum Warenkorb weiter. ---- */
});
